import { setCookie, getCookie } from "./cookies";
import { getLeadRef, persistLeadRef } from "./leadRef";
import { persistAttribution } from "./attribution";

const CONSENT_COOKIE = "sl_consent";

// Consent default staat in <head> van index.html (vóór GTM). Deze module handelt
// alleen de keuze van de bezoeker af en pusht dan pas een consent-update.

export const getStoredConsent = () => {
  try {
    const raw = getCookie(CONSENT_COOKIE);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const updateConsent = ({ analytics, marketing }) => {
  setCookie(CONSENT_COOKIE, JSON.stringify({ analytics, marketing, ts: Date.now() }), 365);
  window.gtag?.("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });
  // Clarity/verdere GTM-tags: eigen dataLayer-event direct na de Google consent-update.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "consent_update",
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });
  if (marketing) {
    persistLeadRef();
    persistAttribution();
  }
  window.dispatchEvent(new Event("consent-updated"));
};

export const hasMarketingConsent = () => getStoredConsent()?.marketing === true;

const pageParams = () => {
  const p = window.__page || {};
  return {
    page_template: p.page_template || "default",
    service: p.service || "algemeen",
    region: p.region || "regio",
  };
};

export const trackEvent = (event, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, lead_ref: getLeadRef(), ...pageParams(), ...params });
};

export const setUserData = ({ email, phone_number }) => {
  window.gtag?.("set", "user_data", {
    ...(email ? { email } : {}),
    ...(phone_number ? { phone_number } : {}),
  });
};

// cta_location: header | hero | sticky_mobile | section | werkwijze | footer | article
export const ctaLocationOf = (el) =>
  el.closest("[data-cta-location]")?.getAttribute("data-cta-location") || "section";

export const logClick = (type, cta_id) => {
  try {
    const body = JSON.stringify({
      type,
      cta_id,
      page_path: window.location.pathname,
      ...(window.__getAttribution ? window.__getAttribution() : {}),
    });
    navigator.sendBeacon(
      `${process.env.REACT_APP_BACKEND_URL}/api/track-click`,
      new Blob([body], { type: "application/json" })
    );
  } catch {
    /* logging mag nooit de klik blokkeren */
  }
};
